import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const [dir, setDir] = useState(0);
  const go = (d) => { setDir(d); setI((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length); };
  const t = TESTIMONIALS[i];

  return (
    <section id="testimonials" className="relative py-24 md:py-32 bg-[#0d0d0d] overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <Reveal><Eyebrow color="#F56FB4">What Our Clients Say</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading font-extrabold uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight mt-3">
              5-Star <span className="text-[#53C653]">Service</span>
            </h2>
          </Reveal>
        </div>

        <Reveal>
          <div className="relative rounded-[2rem] border border-white/10 bg-[#161616]/70 backdrop-blur-xl p-8 md:p-14 min-h-[320px] flex flex-col justify-center">
            <Quote size={64} className="absolute top-8 right-8 text-[#F56FB4]/15" />
            <AnimatePresence mode="wait" custom={dir}>
              <motion.div
                key={i}
                custom={dir}
                initial={{ opacity: 0, x: dir >= 0 ? 40 : -40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: dir >= 0 ? -40 : 40 }}
                transition={{ duration: 0.4 }}
                data-testid="testimonial-active"
              >
                <div className="flex gap-1 mb-5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={22} className="fill-[#FFC83D] text-[#FFC83D]" />
                  ))}
                </div>
                <p className="text-xl md:text-2xl text-white/90 leading-relaxed font-light max-w-3xl">
                  &ldquo;{t.text}&rdquo;
                </p>
                <div className="flex items-center gap-4 mt-8">
                  <div className="h-14 w-14 rounded-full bg-gradient-to-br from-[#F56FB4] to-[#53C653] flex items-center justify-center font-heading font-extrabold text-xl text-white">
                    {t.initial}
                  </div>
                  <div>
                    <p className="font-semibold text-white">{t.name}</p>
                    <p className="text-sm text-white/50">{t.city} · via Google</p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>

            <div className="flex items-center justify-between mt-10">
              <div className="flex gap-2">
                {TESTIMONIALS.map((_, d) => (
                  <button
                    key={d}
                    data-testid={`testimonial-dot-${d}`}
                    onClick={() => { setDir(d > i ? 1 : -1); setI(d); }}
                    className={`h-2 rounded-full transition-all duration-300 ${d === i ? "w-8 bg-[#F56FB4]" : "w-2 bg-white/25"}`}
                    aria-label={`Review ${d + 1}`}
                  />
                ))}
              </div>
              <div className="flex gap-3">
                <button data-testid="testimonial-prev" onClick={() => go(-1)} className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center text-white hover:border-[#F56FB4] hover:text-[#F56FB4] transition-colors">
                  <ChevronLeft size={20} />
                </button>
                <button data-testid="testimonial-next" onClick={() => go(1)} className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center text-white hover:border-[#53C653] hover:text-[#53C653] transition-colors">
                  <ChevronRight size={20} />
                </button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
